/**
 * Parse communities.zmanimSettings from API (string, jsonb array, or invalid legacy data).
 */
export function parseZmanimSettings(raw) {
  if (raw == null || raw === "") return [];
  if (Array.isArray(raw)) return raw;
  // jsonb is usually an array; a plain object is not a valid settings list here
  if (typeof raw === "object") return [];
  if (typeof raw !== "string") return [];

  const trimmed = raw.trim();
  if (!trimmed.startsWith("[") && !trimmed.startsWith("{")) return [];

  try {
    const parsed = JSON.parse(trimmed);
    return Array.isArray(parsed) ? parsed : [];
  } catch {
    return [];
  }
}
